import React, { useEffect } from 'react'

import { Switch, Redirect } from 'react-router-dom';
import { useAuth } from "../../contexts/AuthProvider";

import { ToastContainer, toast } from 'react-toastify';
const Logout = () => {


    const { signOut } = useAuth();
    signOut();
    useEffect(() => {
        signOut();
    }, [])

    try {
        signOut();
        toast.success("از حساب کاربری خود خارج شدید", {
            position: toast.POSITION.TOP_CENTER
        });

    } catch (error) {
        console.log(error);
        toast.error("مشکلی پیش آمده", {
            position: toast.POSITION.TOP_CENTER
        });
    }
    return (
        <Switch>
            <Redirect to="/" />
            <ToastContainer rtl={true} theme="dark" />
        </Switch>
    );
};

export default Logout;